import { type Components } from "@mui/material/styles";

export const formControlLabel: Components["MuiFormControlLabel"] = {
  defaultProps: {
    labelPlacement: "end",
  },
};
